
import { User } from "../Models/Models";
import RespondClient from "../Models/RespondClient";
import { getApiHost } from "../util";
import { getInstance } from "./InstanceProvider";

export default class UserProvider {
    public userProvider: UserProvider | undefined;

    public init() {
        if (!this.userProvider) {
            this.userProvider = new UserProvider();
        }
    }

    public current(): Promise<RespondClient<User>> {
        return getInstance().get(`${getApiHost()}/auth/current`);
    }

    public getToken(): Promise<RespondClient<string>> {
        return getInstance().get(`${getApiHost()}/auth/token`);
    }

    public standaloneLogin(username: string, password: string): Promise<RespondClient<string>> {
        return getInstance().post(`${getApiHost()}/auth/standalone/login`, {
            username,
            password
        });
    }
}

export const UserProviderInstance = new UserProvider();
